<template>
    <v-text-field
      v-model="search"
      prepend-inner-icon="mdi-magnify"
      label="Search"
      variant="solo-filled"
      max-width="1000"
      rounded
    >
    <template #append-inner>
      <v-btn
        :key="isSearch"
        icon
        size="small"
        @click="handleClick"
        variant="tonal"
        :class="isSearch ? 'bg-black' : 'bg-grey-lighten-4'"
      >
        <v-icon :color="isSearch ? 'white' : 'grey-darken-1'">mdi-arrow-up</v-icon>
      </v-btn>
    </template>
    </v-text-field>
</template>

<script>
export default {
    data() {
        return {
        search: '',
        };
    },
    computed: {
        isSearch() {
            return this.search.trim().length > 0;
        }
    },
    methods: {
        handleClick() {
            if (this.isSearch) {
                this.$router.push({ name: 'status', params: { id: this.search } });
                this.search = '';
            } else {
                console.log('there is nothing to search');
            }
            
        }
    }
};
</script>

  